import * as React from 'react';
import { Input, EVisualSize } from '@cian/ui-kit/prev';
import { Label } from './Label';
import { Field } from 'formik';
import { useFieldHasErrors } from './utils';
import * as styles from '../index.css';

export const PetsInfo = () => {
  const invalid = useFieldHasErrors('petsInfo');

  return (
    <div className={styles['field']}>
      <Label invalid={invalid}>Какие животные</Label>
      <Field
        name="petsInfo"
        as={Input}
        placeholder="Кошка, собака и т.д."
        custom={{ invalid, size: EVisualSize.DESKTOP }}
      />
    </div>
  );
};
